(function () {
  if (typeof confetti !== 'function') return;

  const BRAND_COLORS = [
    '#ff0090',
    '#000000',
    '#ffffff',
    '#999999'
  ];

  let lastItemCount = null;

  function fireConfetti() {
    const isMobile = window.innerWidth < 768;
    const particleBase = isMobile ? 50 : 40;
    const bursts = isMobile ? 8 : 6; // number of mini bursts
    const originY = isMobile ? 0.35 : 0.15;

    // Main round explosion
    for (let i = 0; i < bursts; i++) {
      confetti({
        particleCount: particleBase,
        startVelocity: 30 + Math.random() * 20,
        gravity: 0.85,
        ticks: 400 + Math.random() * 50,
        scalar: 1 + Math.random() * 0.3,
        spread: 360, // full circular explosion
        origin: {
          x: 0.5 + (Math.random() - 0.5) * 0.2, // slight horizontal jitter
          y: originY + (Math.random() - 0.5) * 0.1 // slight vertical jitter
        },
        colors: BRAND_COLORS
      });
    }
  }

  function getCartCount() {
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => cart.item_count)
      .catch(() => null);
  }

  // Initialize cart count
  getCartCount().then(count => {
    lastItemCount = count;
  });

  // Watch for clicks → then check cart
  document.addEventListener('click', () => {
    setTimeout(() => {
      getCartCount().then(count => {
        if (count === null) return;
        if (lastItemCount !== null && count > lastItemCount) {
          fireConfetti();
        }
        lastItemCount = count;
      });
    }, 700);
  });
})();
